'use client'
import { useRef } from 'react'
import { useSearchCriteriaStore } from './useSearchCriteriaStore'
import type { ResultDisplay } from '@/domains/agenceSite/agenceSite.types'
import { useEstimateFormStore } from './useEstimateFormStore'

export function StoreInitializer({
  formatAffichage,
  activerServiceAchat
}: {
  formatAffichage: ResultDisplay,
  activerServiceAchat: boolean
}) {
  const initialized = useRef(false)
  if (!initialized.current) {
    useSearchCriteriaStore.setState({
      displayType: formatAffichage === 'liste' || formatAffichage === 'liste_carte' ? 'list' : 'grid',
      displayMap: formatAffichage === 'grille_carte' || formatAffichage === 'liste_carte' ? true : false,
    })
    useEstimateFormStore.setState({
      type: activerServiceAchat ? 'sell' : 'rent',
    })
    initialized.current = true
  }
  return null
}
